import { all, call, fork, put, takeEvery } from "redux-saga/effects";

//Account job Management
import {
  GET_DATA,
  GET_JOBS_BY_FILTER,
  GET_JOBS_BY_LIST,
  GET_JOBS_BY_SEARCH,
  GET_JOB_STATUS,
  GET_MANAGE_LINK,
  GET_SEARCH_DATA,
  JOB_DELETE,
  JOB_DISTRIBUTION,
  JOB_LIST,
  JOB_SEARCH,
} from "./actionTypes";
import {
  deleteJobFailed,
  deleteJobSuccessful,
  getJobStatusDataFailed,
  getJobStatusDataSuccessful,
  getJobsByFilterFailed,
  getJobsByFilterSuccess,
  getJobsByListFailed,
  getJobsByListSuccess,
  getJobsBySearchFailed,
  getJobsBySearchSuccess,
  getMangeLinkFailed,
  getMangeLinkSuccessful,
  jobDistributionFail,
  jobDistributionSuccess,
  jobListFailed,
  jobListSuccessful,
  jobSearchListFailed,
  jobSearchListSuccessful,
} from "./actions";

import {
  deleteJobPost,
  getJobTypeDetails,
  getMangeJobLink,
  jobList,
  jobList2,
  jobSearchList,
  jobSearchList2,
  postCall,
} from "../../../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../../../common/constant/constantURL";

// get job list
function* getJobList({ payload: { user } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    let url;
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_GET_RECRUITER_JOB_LIST;
    } else {
      url = constClass.REST_API_GET_JOB_LIST;
    }
    //calling job list api
    let responsJSON = yield call(jobList, url, user);
    yield put(jobListSuccessful(responsJSON));
  } catch (error) {
    yield put(jobListFailed(error));
  }
}

// get search job list
function* getSearchList({ payload: { user } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    let url;
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_SEARCH_RECRUITER_JOB_LIST;
    } else {
      url = constClass.REST_API_SEARCH_JOB_LIST;
    }

    //calling job list api
    let responsJSON = yield call(jobSearchList, url, user);
    yield put(jobSearchListSuccessful(responsJSON));
  } catch (error) {
    yield put(jobSearchListFailed(error));
  }
}

//jobDistribution
function* jobDistributionHandler({ payload: { distributionJobId } }) {
  try {
    let url = constClass.REST_API_ADD_DISTRIBUTE_JOB;
    let responseJSON = yield call(postCall, url + distributionJobId.jobId);
    if (responseJSON.error) {
      yield put(jobDistributionFail(responseJSON));
    } else {
      yield put(jobDistributionSuccess(responseJSON));
    }
  } catch (error) {
    yield put(jobDistributionFail(error));
  }
}

//JobStatus
function* getViewJobStatus({ payload: { jobId } }) {
  try {
    let url = constClass.REST_API_GET_JOB_STATS;
    let responsJSON = yield call(getJobTypeDetails, url + jobId);

    yield put(getJobStatusDataSuccessful(responsJSON));
  } catch (error) {
    yield put(getJobStatusDataFailed(error));
  }
}

//mangeLinkData
function* getMangeLinkHandler({ payload: { jtJobId } }) {
  try {
    const userId = JSON.parse(localStorage.getItem("authUser")).clientId;
    let url =
      constClass.REST_API_GET_JOB_STATUS + jtJobId + "&userId=" + userId;
    let responsJSON = yield call(getMangeJobLink, url);
    if (responsJSON.statusCode === parseInt("200")) {
      yield put(getMangeLinkSuccessful(responsJSON));
    } else {
      yield put(getMangeLinkFailed(responsJSON));
    }
  } catch (error) {
    yield put(getMangeLinkFailed(error));
  }
}

//Candidate Delete
function* deleteJob({ payload: { user, history } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    let obj = {};
    obj["jobId"] = user;

    let url;
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_GET_RECRUITER_JOB_DELETE;
    } else {
      url = constClass.REST_API_DELETE_JOB;
    }
    //calling candidate list api
    let responsJSON = yield call(deleteJobPost, url, obj);
    yield put(deleteJobSuccessful(responsJSON));
  } catch (error) {
    yield put(deleteJobFailed(error));
  }
}

function* getJobData({ payload: { user } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    let url;
    if (data.userType === "Recruiter") {
      if (user.jobType != null || user.jobType !== undefined) {
        url =
          constClass.REST_API_GET_RECRUITER_JOB_LIST +
          `/${user.page}?jobType=${user.jobType}&time=${user.time}`;
      } else {
        url = constClass.REST_API_GET_RECRUITER_JOB_LIST + `/${user.page}`;
      }
    } else {
      if (user.jobType != null || user.jobType !== undefined) {
        url =
          constClass.REST_API_GET_JOB_LIST +
          `/${user.page}?jobType=${user.jobType}&time=${user.time}`;
      } else {
        url =
          constClass.REST_API_GET_JOB_LIST +
          "page=" +
          user.page +
          "&&type=" +
          user.type;
      }
    }
    let responsJSON = yield call(jobList2, url);
    yield put(jobListSuccessful(responsJSON));
  } catch (error) {
    yield put(jobListFailed(error));
  }
}
function* getSearchJobData({ payload: { user } }) {
  try {
    let url;
    if (user.type === "ACTIVE") {
      url =
        constClass.CANDIDATE_NORMAL_SEARCH +
        `${user.page}?indexType=${user.indexType}&keyword=${user.keyword.SearchKeyword}`;
    } else if (user.type === "CLOSE") {
      url =
        constClass.JOB_INACTIVE_SEARCH +
        `page=${user.page}&keyword=${user.keyword.SearchKeyword}`;
    }

    let responsJSON = yield call(jobSearchList2, url);
    yield put(jobSearchListSuccessful(responsJSON));
  } catch (error) {
    yield put(jobSearchListFailed(error));
  }
}

function* getJobsByListHandler({ payload: { data } }) {
  try {
    let url;

    let data2 = JSON.parse(localStorage.getItem("authUser"));
    if (data2.userType === "RECRUITER") {
      if (data.type === "ACTIVE") {
        url =
          constClass.REST_API_GET_JOBS_BY_LIST_RECRUITER +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber;
      } else if (data.type === "CLOSE") {
        url =
          constClass.REST_API_GET_CLOSE_JOBS_BY_LIST_RECRUITER +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber;
      }
    } else {
      if (data.type === "ACTIVE") {
        url =
          constClass.REST_API_GET_JOBS_BY_LIST +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber;
      } else if (data.type === "CLOSE") {
        url =
          constClass.REST_API_GET_CLOSE_JOBS_BY_LIST +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber;
      }
    }

    if (data.sort !== null && data.sort !== undefined && data.sort !== "") {
      url = url + "&sort=" + encodeURIComponent(data.sort);
    }
    let responsJSON = yield call(jobSearchList2, url);

    yield put(getJobsByListSuccess(responsJSON));
  } catch (error) {
    yield put(getJobsByListFailed(error));
  }
}

function* getJobsByFilterHandler({ payload: { data } }) {
  try {
    let url;
    if (data.type === "ACTIVE") {
      url =
        constClass.REST_API_GET_JOBS_BY_FILTER +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&";
    } else if (data.type === "CLOSE") {
      url =
        constClass.REST_API_GET_CLOSE_JOBS_BY_FILTER +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&";
    }

    if (data.sort !== null) {
      url = url + "sort=" + encodeURIComponent(data.sort) + "&";
    }
    let url2 = "";
    let extentedUrl = data.filter.map((eachObject) => {
      return (url2 =
        eachObject.filterName +
        "=" +
        encodeURIComponent(
          eachObject.condition + "[" + eachObject.value + "]"
        ));
    });

    let responsJSON = yield call(jobSearchList2, url + extentedUrl.join("&"));
    yield put(getJobsByFilterSuccess(responsJSON));
  } catch (error) {
    yield put(getJobsByFilterFailed(error));
  }
}

function* getJobsBySearchHandler({ payload: { data } }) {
  try {
    
    let url;

    if (data.type === "ACTIVE") {
      url =
        constClass.REST_API_GET_JOBS_BY_SEARCH +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&keyword=" +
        data.searchKeyword;
    } else if (data.type === "CLOSE") {
      url =
        constClass.REST_API_GET_CLOSE_JOBS_BY_SEARCH +
        data.pageSize +
        "&pageNumber=" +
        data.pageNumber +
        "&keyword=" +
        data.searchKeyword;
    }

    if (data.sort !== null) {
      url = url + "&sort=" + encodeURIComponent(data.sort);
    }

    let responsJSON = yield call(jobSearchList2, url);
    yield put(getJobsBySearchSuccess(responsJSON));
  } catch (error) {
    yield put(getJobsBySearchFailed(error));
  }
}

export function* watchjobList() {
  yield takeEvery(JOB_LIST, getJobList);
  yield takeEvery(JOB_SEARCH, getSearchList);
  yield takeEvery(GET_JOB_STATUS, getViewJobStatus);
  yield takeEvery(JOB_DISTRIBUTION, jobDistributionHandler);
  yield takeEvery(GET_MANAGE_LINK, getMangeLinkHandler);
  yield takeEvery(JOB_DELETE, deleteJob);
  yield takeEvery(GET_DATA, getJobData);
  yield takeEvery(GET_SEARCH_DATA, getSearchJobData);
  yield takeEvery(GET_JOBS_BY_LIST, getJobsByListHandler);
  yield takeEvery(GET_JOBS_BY_FILTER, getJobsByFilterHandler);
  yield takeEvery(GET_JOBS_BY_SEARCH, getJobsBySearchHandler);
}

function* jobListSaga() {
  yield all([fork(watchjobList)]);
}

export default jobListSaga;
